import { IAddress, ShipmentStatus, ShipmentThirdPartyPreferencesApiResponse } from '@packlink/packlink-sdk';
import { IParcel, PriceConceptInShipment } from '@types';

export enum LabelStatus {
    NOT_REQUESTED = 'NOT_REQUESTED',
    READY = 'READY',
    PROCESSING = 'PROCESSING',
    CANCELLED = 'CANCELLED',
}

export interface IShipmentPriceItem {
    base_price: number;
    concept: PriceConceptInShipment;
    extra_data: Record<string, string>;
    tax_price: number;
    total_price: number;
}

export interface IShipmentCustoms {
    customs_invoice_id: string;
}

export interface IShipmentPrice {
    base_price: number;
    items: IShipmentPriceItem[];
    tax_price: number;
    total_price: number;
}

export interface IShipmentItem {
    category_name?: string;
    currency: string;
    item_id: string;
    picture_url: string;
    price: number;
    quantity: number;
    title: string;
}

export interface IAdditionalData {
    items?: IShipmentItem[];
    shipping_service_cost?: number;
    shipping_service_cost_currency?: string;
    shipping_service_name?: string;
    order_id?: string;
    sale_price?: number;
    shipping_pick_up_point_id_selected: string | null;
    shipping_service_id_selected: string | null;
}

export interface IShipment {
    adult_signature: boolean;
    packlink_reference: string;
    labels?: string[];
    additional_data: IAdditionalData;
    content: string;
    contentvalue: number;
    content_second_hand: boolean;
    state: ShipmentStatus;
    trackings?: string[];
    source: string;
    currency: string;
    customs: IShipmentCustoms | null;
    price: IShipmentPrice;
    packages?: IParcel[];
    print_in_store: {
        qr_url: string;
        qr_reference: string;
    };
    print_in_store_selected: boolean;
    carrier: string;
    service: string;
    service_id: number;
    shipment_custom_reference?: string;
    from: IAddress;
    to: IAddress;
    dropoff_point_id?: string;
    order_date?: string;
    service_info: {
        has_paperless_customs: boolean;
    };
    third_party_preferences?: ShipmentThirdPartyPreferencesApiResponse;
}

export interface IQR {
    reference: string;
    url: string;
}
